import http from '../../Http-common';

const getAll = (page, length) => {
    return http.get(`/admin/commentator/list?draw=1&start=1&length=100&keyword&startDate&endDate`);
}

const getById = (id) => {
    return http.get(`/admin/commentator?id=${id}`);
}

const create = (formData) => {
    return http.post('/admin/commentator', formData,{
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}
const update = (formData) => {
    return http.post(`/admin/commentator`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    })
}
const deleted = (ids) => {
    return http.delete(`/admin/commentator?ids=${ids}`);
}

const CommentatorService = {
    getAll,
    getById,
    create,
    update,
    deleted,
}

export default CommentatorService;